"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryWrapper = void 0;
const react_query_1 = require("react-query");
function useQueryWrapper(queryKey, queryFn, options) {
    if (options.enabled === undefined)
        options.enabled = false;
    return (0, react_query_1.useQuery)(queryKey, queryFn, options);
}
exports.useQueryWrapper = useQueryWrapper;
